export default {
  presenter: 'juras',
  title: 'Vývin, pohyb, učenie sa',
  subtitle: 'Vďaka mozgu sa pohybujeme, vďaka pohybu sa rozvíja mozog.',
  text: `
Vďaka mozgu sa pohybujeme, vďaka pohybu sa rozvíja mozog.
A vďaka rozvíjajucemu sa mozgu sa učíme.
Neuroplasticita, neuromotorická nezrelosť, špecifické poruchy učenia, poruchy správania, deti s mimoriadnym nadaním... to je iba zopár z aktuálne stále viac diskutovaných tém. Ako tieto témy súvisia a čo nám hovoria o dieťati a ako to možeme využiť v prospech detí? Ako môžeme pomôcť deťom vyvíjať sa správne a dosahovať ich potenciál.​
  
Lekár, socioterapeut, terapeut INPP a Benaudira. Patrí medzi aktívnych členov Inštitútu psychoterapie a socioterapie, pravidelne prednáša a publikuje. Je zároveň zriaďovateľom materskej a základnej školy M. Montessori v Bratislave. Je spoluautorom dokumentu Učiace sa Slovensko.
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/p03_vyvin_pohyb.js